import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ModalCommunicationService {
  private closeModalSubject = new Subject<void>();

  closeModal$ = this.closeModalSubject.asObservable();

  closeModal() {
    this.closeModalSubject.next();
  }
}
